<template>
  <section class="mainBody">
    <div class="header">停发查询</div>
    <div class="content">
        <div class="row">
            <div class="title"><span>*</span>快递公司</div>
            <div>
            <el-select v-model="compony" placeholder="请选择快递公司" size="small">
                <el-option
                v-for="item in componyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            </div>
        </div>
        <div class="row">
            <div class="title">寄件地址</div>
            <div>
            <el-cascader
                size="small"
                @change="changeAddress('send')"
                ref="send"
                :options="sender_address"
                v-model="sendpca"
                placeholder="请选择省/市/区"
                filterable
            ></el-cascader>
            </div>
            <div class="xqaddress"><el-input v-model="send.address" size="small" placeholder="请输入详细地址"></el-input></div>
            <div class="tips"><i class="el-icon-warning-outline"></i>非必填项，填写后查询更精准</div>
        </div>
        <div class="row">
            <div class="title"><span>*</span>收件地址</div>
            <div>
            <el-radio-group v-model="chooseModel" size="mini">
              <el-radio-button label="填"></el-radio-button>
              <el-radio-button label="选"></el-radio-button>
            </el-radio-group>
            </div>
        </div>
        <div class="row" style="position: relative;">
            <div class="title"></div>
            <el-form ref="chooseRlue" :model="collect" :inline="true" v-show="chooseModel == '选'">
               <el-form-item   :rules="[{ required: true, message: '省市区不可为空'}]" prop="collectpca">
                <el-cascader
                    @change="changeAddress('collect')"
                    ref="collect"
                    size="small"
                    :options="sender_address"
                    v-model="collect.collectpca"
                    placeholder="请选择省/市/区"
                    filterable  
                ></el-cascader>
               </el-form-item>
               <el-form-item :rules="[{ required: true, message: '详情地址不可为空'}]" prop="address" >
                    <el-input v-model="collect.address" size="small" placeholder="请输入详细地址" style="width: 350px;"></el-input>
               </el-form-item>
            </el-form>           
            <div style="width:560px;position: relative;" v-show="chooseModel == '填'">
                <el-form ref="textRule" :model="collectText">
                    <el-form-item prop="text" :rules="[{ required: true, message: '收件地址不可为空'}]">
                    <el-input
                    type="textarea"
                    placeholder="直接粘贴收件地址、多个地址可用；或者回车(Enter)分割，单次最多支持查询10条地址。例如:“上海市浦东区陆家嘴金融大厦22层”"
                    v-model="collectText.text"
                    maxlength="1000"></el-input>                     
                    </el-form-item>
                </el-form>
                <div class="clearText" @click="clearText">清空</div>
            </div>
            <div class="btnsgroup">
                <el-button type="primary" size="small" @click="getData" icon="el-icon-search">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="reset">重置</el-button>            
            </div>            
        </div>
        <div class="stoptable" id="mytable">
           <el-table size="mini" :data="tableData">
             <el-table-column type="index" label="序号"></el-table-column>
             <el-table-column label="快递公司" prop="company" align="center"></el-table-column>
             <el-table-column label='收件地址' prop="detail_address" align="center"></el-table-column>
             <el-table-column label='可达情况' align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.close == 0" style="color:#67C23A;font-weight: bold;">可达</span>
                    <span v-else style="color:#F56C6C;font-weight: bold;">不可达</span>
                </template>
             </el-table-column>
           </el-table> 
        </div>
    </div>
  </section>
</template>
<script>
let receiver_address = [];
import face from '@/api/face';
import home from '@/api/home';
import util from "@/util/util";
export default {
    name:'stopArea',
    data(){
        return{
            tableData:[],
            compony:'yunda',
            chooseModel:'填',
            componyList:[
                {value:'yunda',label:'韵达快递'},
                {value:'zto',label:'中通快递'},
                {value:'yto',label:'圆通快递'},
            ],
            sender_address: [],
            sendpca:[],
            send:{
                province:'',
                city:'',
                area:'',
                address:''
            },
            collect:{
                collectpca:[],
                province:'',
                city:'',
                area:'',
                address:''
            },
            collectText:{
              text:''
            },
            defaultsendAddress:'',
        }
    },
    mounted(){
      this.sender_address = this.ysbAddressFile.getcity()
      this.getmorenAddress();
    },
    methods:{
      /** 获取默认寄件地址 */
      getmorenAddress() {
        home.getDefaultAddress(this).then((res) => {
        if (res.success && res.data.id) {
          const data = res.data;
          this.defaultsendAddress = data.province_name+data.city_name+data.district_name+data.address
        }else{
          this.defaultsendAddress = '上海市青浦区盈港东路6679号' 
        }
        })
      },
      reset(){
         this.compony = 'yunda';
         this.chooseModel = '填';
         this.sendpca = [];
         this.send = {
            province:'',
            city:'',
            area:'',
            address:''
        };
        this.collect = {
            province:'',
            city:'',
            area:'',
            address:'',
            collectpca:[],
        };
        this.collectText = {
            text:''
        };
        this.tableData = [];
        if(this.chooseModel == '填'){
          this.$refs.textRule.resetFields();  
        }else{
          this.$refs.chooseRlue.resetFields();  
        }    
      },  
      changeAddress(type) {
        if (!type) return
        let address = this.$refs[type].getCheckedNodes()[0].pathLabels // 地址显示
        this[type].province = address[0]
        this[type].city = address[1]
        this[type].area = address[2]
      },   
      getData(){
        if(this.chooseModel == '填'){
            this.$refs.textRule.validate((valid) => {
            if (valid) {
                this.anaopt(()=>{this.search()})
            } else {
                console.log('error submit!!');
                return false;
            }
            });            
        }else{
            receiver_address = [];
            this.$refs.chooseRlue.validate((valid) => {
            if (valid) {
                receiver_address = [{'addr':this.collect.province+this.collect.city+this.collect.area+this.collect.address}] 
                this.search()
            } else {
                console.log('error submit!!');
                return false;
            }
            });  
        }

      },
      anaopt(callback){
        home.doAnalysis(this,this.collectText.text).then(res=>{
            if(res.success){
              let data = res.data;
              let filterData = data.filter((el)=>{
                return (el.province_code&&el.city_code&&el.district_code&&el.address)
              })
              if(data.length > filterData.length){
                const num = data.length - filterData.length
                util.gj_message(num+'条解析失败，请完善省市区及详细地址')
              }
              receiver_address = [];
              filterData.forEach((c)=>{
                receiver_address.push({'addr':c.origin_address})
              })
              if(receiver_address.length == 0){
                return
              }
              if(receiver_address.length > 10){
                util.gj_message('批量查询停发区地址不可大于10条')
                return
              }
              callback()
            }
        })
      },  
      search(){
        const senderAddress = this.send.province+this.send.city+this.send.area+this.send.address
        const query = {
            "company_type": this.compony,
            "sender_address": senderAddress?senderAddress:this.defaultsendAddress,
            "receiver_address": receiver_address
        }
        face.stopAreaSearch(this,query).then(res=>{
            if(res.success){
             this.tableData = res.data
            }
        })
      },
      clearText(){
        this.collectText = {text:''};
        this.$refs.textRule.resetFields();  
      },
    }
}
</script>
<style lang="stylus" scoped>
.mainBody{
    padding 10px 30px
}
.header{
    font-size 16px;
    font-weight bold
    border-bottom  1px solid #DCDFE6  
    line-height 50px
    color #2ea2fc   
}
.content{
    font-size: 14px;
}
.row{
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    .title{
        width: 120px;
        text-align: right;
        padding-right: 20px;
        span{
            color:red;
            vertical-align: sub;
            margin-right: 4px;
        }
    }
}
.tips{
    font-size: small;
    color: #409EFF;
    padding-left: 10px;
}
.xqaddress{
    padding-left: 10px;
    width 350px;
}
.btnsgroup{
    position: absolute;
    bottom :30px;
    right: 0;
    z-index 99
}
.stoptable{
    border-top: 4px solid #f5f5f5;
}
.clearText{
    position: absolute;
    bottom: 26px;
    right: 10px;
    z-index: 9;
    cursor: pointer;
    font-size: small;
    color:#409EFF;
}
</style>